import {
  ChangeDetectionStrategy,
  Component,
  inject
} from "@angular/core";
import { Dialog } from 'primeng/dialog';
import { LoadScreenService } from "../../load-screen.service";
import { FullScreenLoaderComponent } from '../../../../components/full-screen-loader/full-screen-loader';

@Component({
  selector: "velocity-loader-dialog",
  templateUrl: "./loader-dialog.component.html",
  styleUrls: ["./loader-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Dialog,
    FullScreenLoaderComponent,
  ],
})
export class LoaderDialogComponent {
  private loadScreenService = inject(LoadScreenService);

  message = this.loadScreenService.message;

  loading = this.loadScreenService.isOpen;

  image = this.loadScreenService.image;

  opaque = this.loadScreenService.isOpaque;

  fullScreen = this.loadScreenService.isFullScreen;
}
